'use client';

import { useReportWebVitals } from 'next/web-vitals';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
const logWebVitals = (metric) => {
    try {
        // eslint-disable-next-line no-console
        console.log(JSON.parse(JSON.stringify(metric)));
    } catch (e) {
        console.error(e, metric);
    }
};

export function WebVitals() {
    useReportWebVitals(logWebVitals);

    return null;
}
